import { apiGet, apiPost, apiPutId, apiDelete, unwrapPaginated, unwrapData } from './helpers'

/** Enrolamiento compartido (regular + insurance). */
const SHARED_PATH = 'weightloss/patients'

/**
 * @param {string} lanePath - `weightloss/patients` | `insurance/weightloss/patients`
 */
export function createPatientsApi(lanePath) {
  return {
    listPaginated: (perPage = 10, params = {}, page = 1) =>
      apiGet(`${lanePath}/${Number(perPage) || 10}`, {
        ...params,
        page: Number(page) || 1,
      }).then(unwrapPaginated),
    getById: id => apiGet(`${lanePath}/detail/${id}`).then(unwrapData),
    /** POST compartido: el carril lo define has_insurance del user_id */
    create: data => apiPost(SHARED_PATH, data),
    update: (id, data) => apiPutId(SHARED_PATH, id, data),
    remove: id => apiDelete(`${SHARED_PATH}/${id}`),
  }
}

const wlPatientsApi = createPatientsApi('weightloss/patients')
export const wlPatientsInsuranceApi = createPatientsApi('insurance/weightloss/patients')

export default wlPatientsApi
